import { render, staticRenderFns } from "./ApplicationLetter.vue?vue&type=template&id=55a19e07&scoped=true&"
import script from "./ApplicationLetter.vue?vue&type=script&lang=js&"
export * from "./ApplicationLetter.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationLetter.vue?vue&type=style&index=0&id=55a19e07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a19e07",
  null
  
)

export default component.exports